import script from "./WorkloadByStatusChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkloadByStatusChart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__